import { MaskLines } from "@/components/common/Reveal";
import { motion } from "framer-motion";

export const PageHeader = ({ label, lines, intro, children }) => (
  <section className="grain relative overflow-hidden pt-32 pb-14 sm:pt-40 sm:pb-20">
    <div
      aria-hidden
      className="halo pointer-events-none absolute -top-56 left-0 h-[560px] w-[900px]"
    />
    <div className="shell relative">
      {label && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="label"
        >
          {label}
        </motion.p>
      )}
      <h1 className="font-display mt-6 max-w-4xl text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
        <MaskLines lines={lines} delay={0.1} />
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.42, ease: [0.16, 1, 0.3, 1] }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-gray-400 sm:text-lg"
        >
          {intro}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
